/* MARMOT U1: чиста логика за ъпселинга в количката (без DOM).
   UMD: window.MarmotUpsellLogic в браузъра и module.exports в Node. */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.MarmotUpsellLogic = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  function uniqueAges(values) {
    var seen = {};
    return (values || []).map(function (value) {
      var age = Number(value);
      if (!Number.isFinite(age) || age < 1) return null;
      return Math.min(11, Math.floor(age));
    }).filter(function (age) {
      if (age === null || seen[age]) return false;
      seen[age] = true;
      return true;
    }).sort(function (a, b) { return a - b; });
  }

  /* Възрастта НЕ идва от таговете на продукта: в Shopify те са празни (проверено
     по живите данни, 24.08.2026). Идва от възрастовите колекции „N+ години"
     (handle „N-години"), които `snippets/marmot-age-range.liquid` чете и подава
     насам като токени „3+ 4+ 5+". Тук се разчитат само тези токени. */
  function parseAgeTokens(tokens) {
    var list = Array.isArray(tokens) ? tokens : String(tokens || '').split(/[\s,]+/);
    return uniqueAges(list.map(function (token) {
      var match = String(token).trim().match(/^(\d+)\+$/);
      return match ? Number(match[1]) : null;
    }));
  }

  function agesFromRange(min, max) {
    var lo = Math.max(1, Math.floor(Number(min) || 0));
    var hi = Math.min(11, Math.floor(Number(max) || 0));
    var ages = [];
    if (!lo || !hi || lo > hi) return ages;
    for (var age = lo; age <= hi; age += 1) ages.push(age);
    return ages;
  }

  function itemAges(item) {
    if (Array.isArray(item && item.ages)) return uniqueAges(item.ages);
    return agesForProduct(item);
  }

  function agesForProduct(product) {
    if (!product) return [];
    if (Array.isArray(product.ages)) return uniqueAges(product.ages);
    var exact = parseAgeTokens(product.ageTokens);
    if (exact.length) return exact;
    return agesFromRange(product.ageMin, product.ageMax);
  }

  /* Индекс productId → възрасти, събран от единствения източник, който ги знае:
     Liquid-а. Началните артикули покриват количката при зареждане, кандидатите –
     всичко, което нашият бутон „Добави" може да сложи в нея после. */
  function buildAgeIndex() {
    var index = {};
    for (var i = 0; i < arguments.length; i += 1) {
      var list = Array.isArray(arguments[i]) ? arguments[i] : [];
      for (var j = 0; j < list.length; j += 1) {
        var entry = list[j];
        var key = entry && entry.productId != null ? String(entry.productId) : '';
        if (!key || index[key]) continue;
        var ages = agesForProduct(entry);
        if (ages.length) index[key] = ages;
      }
    }
    return index;
  }

  function cartItemAgeRecord(cartItem, ageIndex) {
    cartItem = cartItem || {};
    var key = cartItem.product_id != null ? String(cartItem.product_id) : '';
    var known = ageIndex && ageIndex[key];
    return {
      productId: cartItem.product_id,
      priceCents: Number(cartItem.final_price != null ? cartItem.final_price : cartItem.price) || 0,
      ages: Array.isArray(known) ? known.slice() : []
    };
  }

  function cartBasisCents(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce(function (sum, item) {
      return sum + (Number(item && item.final_line_price) || 0);
    }, 0);
  }

  function resolveTargetAge(items) {
    var list = Array.isArray(items) ? items : [];
    if (!list.length) return { ages: [], source: 'neutral' };

    /* Липсваща възраст прави персонализирания надпис недоказуем. Секцията остава
       активна, но минава в неутрален режим и пази ръчния ред на колекцията. */
    var ageLists = list.map(itemAges);
    if (ageLists.some(function (ages) { return ages.length === 0; })) {
      return { ages: [], source: 'neutral' };
    }

    var common = ageLists[0];
    for (var i = 1; i < ageLists.length; i += 1) {
      var next = ageLists[i];
      common = common.filter(function (age) { return next.indexOf(age) !== -1; });
    }
    if (!common.length) return { ages: [], source: 'neutral' };
    return { ages: common, source: 'intersection' };
  }

  /* Надписът е ФИКСИРАН (решение на Николай, 25.08.2026). Възрастта остава само
     вътрешна ПОДРЕДБА и никога не се изписва: заглавие с възраст обещаваше на
     купувача нещо, което подборът не може да гарантира, и свиваше рафта, когато
     колекцията няма книги точно за тази възраст. Функцията не приема аргументи
     нарочно – няма вход, който да промени надписа. */
  function recommendationTitle() {
    return 'Още от най-продаваните ни книги';
  }

  function shippingProgress(subtotalCents, thresholdCents, inclusive) {
    var subtotal = Math.max(0, Math.round(Number(subtotalCents) || 0));
    var threshold = Math.max(0, Math.round(Number(thresholdCents) || 0));
    var includesBoundary = inclusive !== false;
    var free = threshold > 0 && (subtotal > threshold || (subtotal === threshold && includesBoundary));
    var remaining = 0;
    if (threshold > 0 && !free) {
      remaining = Math.max(0, threshold - subtotal + (includesBoundary ? 0 : 1));
    }
    var percent = threshold > 0 ? Math.min(100, Math.max(0, subtotal / threshold * 100)) : 0;
    if (!free && percent >= 100) percent = 99;
    return { free: free, remainingCents: remaining, percent: percent };
  }

  function candidateAges(candidate) {
    return agesForProduct(candidate);
  }

  /* Възрастта ПОДРЕЖДА, а не отсява (решение на Николай, 25.08.2026): съвпадащите
     по възраст излизат първи, след тях останалите от колекцията по ръчния ѝ ред.
     Така рафтът е винаги с три книги, докато колекцията има какво да предложи, а
     възрастта пак си личи – в кои книги вижда купувачът най-отгоре. */
  function orderedCandidates(candidates, targetAges, cartProductIds) {
    var inCart = {};
    var wantedAges = Array.isArray(targetAges) ? uniqueAges(targetAges) : uniqueAges([targetAges]);
    (cartProductIds || []).forEach(function (id) { inCart[String(id)] = true; });

    var available = (candidates || []).filter(function (candidate) {
      return candidate && candidate.available === true && !inCart[String(candidate.productId)];
    });
    if (!wantedAges.length) return available;

    var matching = [];
    var rest = [];
    available.forEach(function (candidate) {
      var ages = candidateAges(candidate);
      var matches = wantedAges.some(function (age) { return ages.indexOf(age) !== -1; });
      (matches ? matching : rest).push(candidate);
    });
    return matching.concat(rest);
  }

  function slot(candidate, position, kind) {
    return {
      position: position,
      kind: kind,
      product: candidate,
      regularPriceCents: Number(candidate.priceCents) || 0,
      promoPriceCents: null,
      promoBadge: null
    };
  }

  function selectSlots(options) {
    options = options || {};
    var eligible = orderedCandidates(
      options.candidates,
      Object.prototype.hasOwnProperty.call(options, 'targetAges') ? options.targetAges : options.targetAge,
      options.cartProductIds
    );
    var progress = shippingProgress(
      options.subtotalCents,
      options.thresholdCents,
      options.inclusive
    );
    var chosen = [];

    if (progress.free) {
      return eligible.slice(0, 3).map(function (candidate, index) {
        return slot(candidate, index + 1, 'priority');
      });
    }

    eligible.slice(0, 2).forEach(function (candidate, index) {
      chosen.push(slot(candidate, index + 1, 'priority'));
    });
    var chosenIds = {};
    chosen.forEach(function (entry) { chosenIds[String(entry.product.productId)] = true; });

    var remainingCandidates = eligible.filter(function (candidate) {
      return !chosenIds[String(candidate.productId)];
    });
    var filler = remainingCandidates.filter(function (candidate) {
      return !chosenIds[String(candidate.productId)] &&
        Number(candidate.priceCents || 0) >= progress.remainingCents;
    }).sort(function (a, b) {
      return Number(a.priceCents || 0) - Number(b.priceCents || 0);
    })[0];

    if (filler) chosen.push(slot(filler, 3, 'threshold-filler'));
    else if (remainingCandidates[0]) chosen.push(slot(remainingCandidates[0], 3, 'priority-fallback'));
    return chosen.slice(0, 3);
  }

  function markCandidateUnavailable(candidates, productId) {
    return (candidates || []).map(function (candidate) {
      if (String(candidate.productId) !== String(productId)) return candidate;
      var next = {};
      Object.keys(candidate).forEach(function (key) { next[key] = candidate[key]; });
      next.available = false;
      return next;
    });
  }

  function addFailureAction(status) {
    if (Number(status) === 422) {
      return {
        kind: 'sold-out',
        label: 'Изчерпана',
        message: 'Изчерпана. Показахме друго заглавие, ако има подходящо.',
        removeCandidate: true
      };
    }
    return {
      kind: 'retry',
      label: 'Опитай пак',
      message: 'Възникна грешка. Опитай пак.',
      removeCandidate: false
    };
  }

  function cartRenderSelectors() {
    return ['.js-contents-cart-items-empty', '.js-contents-cart-items', '.js-contents-subtotal'];
  }

  function isStaleRound(requestRound, currentRound) {
    return Number(requestRound) !== Number(currentRound);
  }

  function candidateRowPlan(slots, candidateIds) {
    var ordered = (slots || []).map(function (entry) { return String(entry.product.productId); });
    var visible = {};
    ordered.forEach(function (id) { visible[id] = true; });
    return {
      orderedProductIds: ordered,
      hiddenProductIds: (candidateIds || []).map(String).filter(function (id) { return !visible[id]; })
    };
  }

  /* Баджът „покрива доставката" е премахнат (решение на Николай, 25.08.2026) –
     затова и функцията, която решаваше кога да се показва. Самият подбор на
     третия слот по остатъка до прага остава: той подрежда, надписът беше само
     обяснение върху корицата. */

  function progressLabelMode(progress) {
    return progress && progress.free === true ? 'complete' : 'remaining';
  }

  function copyShippingConfig(config) {
    return {
      thresholdCents: Number(config && config.thresholdCents) || 0,
      inclusive: !config || config.inclusive !== false
    };
  }

  function money(cents, dual) {
    var value = Math.max(0, Math.round(Number(cents) || 0));
    var euros = Math.floor(value / 100);
    var euroCents = value % 100;
    var text = euros + ',' + (euroCents < 10 ? '0' : '') + euroCents + ' €';
    if (dual !== true) return text;
    var leva = Math.floor((value * 195583 + 50000) / 100000);
    var levaWhole = Math.floor(leva / 100);
    var levaCents = leva % 100;
    return text + ' (' + levaWhole + ',' + (levaCents < 10 ? '0' : '') + levaCents + ' лв)';
  }

  return {
    parseAgeTokens: parseAgeTokens,
    agesFromRange: agesFromRange,
    agesForProduct: agesForProduct,
    buildAgeIndex: buildAgeIndex,
    cartItemAgeRecord: cartItemAgeRecord,
    cartBasisCents: cartBasisCents,
    resolveTargetAge: resolveTargetAge,
    recommendationTitle: recommendationTitle,
    shippingProgress: shippingProgress,
    orderedCandidates: orderedCandidates,
    selectSlots: selectSlots,
    markCandidateUnavailable: markCandidateUnavailable,
    addFailureAction: addFailureAction,
    cartRenderSelectors: cartRenderSelectors,
    isStaleRound: isStaleRound,
    candidateRowPlan: candidateRowPlan,
    progressLabelMode: progressLabelMode,
    copyShippingConfig: copyShippingConfig,
    money: money
  };
});
